import axiosWithToken from '@/api/axios'
import { adminBaseUrl } from '@/store'
import { postMethodConfig } from '@/api/axios'

const state = () => ({
  faq: [],
  isLoading: false
})

const getters = {
  faq: (state) => state.faq,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_FAQ(state, payload) {
    state.faq = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  fetchFaq({ commit, dispatch }, { vm }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get(vm.apiUrl)
      .then((res) => {
        const message = res.data.message
        commit('SET_FAQ', message.data)
        vm.page = message.current_page
        vm.perPage = message.per_page
        vm.numberOfPages = message.last_page
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  createSingleFaq({ dispatch }, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/faq`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/faq')
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  deleteSingleFaq(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/faq/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  },
  fetchSingleFaq(_context, { id, vm }) {
    vm.isLoading = true
    axiosWithToken
      .get(`${adminBaseUrl}/faq/${id}`)
      .then((res) => {
        const message = res.data.message
        vm.editForm.questionEn = message.question_en
        vm.editForm.questionRu = message.question_ru
        vm.editForm.answerEn = message.answer_en
        vm.editForm.answerRu = message.answer_ru
        vm.editForm.sort = message.sort
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  updateSingleFaq(_context, { payload, id, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    data.append('_method', 'PUT')

    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/faq/${id}`, data, postMethodConfig)
      .then(() => {
        vm.$refs['editSingleFaqModal'].hide()
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
